// 画面に出す文(日本語)。英語は en.js に同じキーで書く(キーの並びもそろえる)。
// {name} の所は、コードから渡す値に置きかわる。
// キーの名前: 「場所.中身」。武器・ステージなど id があるものは「種類.id.中身」(コードでは id から組み立てる)。
// 新しい文を足すときは、ここと en.js の両方に足す(npm test で抜けを調べる)。

export default {
  // ---- 共通 ----
  "list.sep": "・",
  "lang.auto": "AUTO",
  "lang.toggle": "English", // タイトルの言語ボタン(押すと切り替わる先の言語の名前)

  // ---- タイトル ----
  "title.subtitle": "3分間、生き残れ。",
  "title.start": "出撃",
  "title.hangar": "格納庫",
  "title.howto1": "移動: WASD / 矢印 / ゲームパッド / 画面をなぞる",
  "title.howto2": "攻撃はすべて自動。経験値を集めて強化を選ぼう。",
  "title.howto3": "撃墜されても R.W.N.D. で好きな所から戻れる。",
  "title.sister": "本当の戦場 SENSEOFVOID はこちら",
  "title.credits": "BGM　MFP【Marron Fields Production】さん ／ 効果音　OtoLogic(CC BY 4.0)・効果音ラボ ／ 一部の画像は Google Gemini、オペレーターの顔は ChatGPT で生成 ／ Three.js",
  "title.meta": "{dopa} DOPA ・ ベスト前進 {progress} ・ 最多撃墜 {kills}",
  "install.button": "ホーム画面に追加",
  "install.title": "ホーム画面に追加",
  "install.ios": "Safari の共有ボタン（四角に上向きの矢印。iPhone は画面の下、iPad は右上）を押して、「ホーム画面に追加」を選んでください。LINE や X の中で開いているときは、先に Safari で開き直してください。",
  "install.android": "ブラウザのメニュー（右上の ⋮）を開いて、「ホーム画面に追加」または「アプリをインストール」を選んでください。",
  "install.note": "ホーム画面から開くと、アドレスバーの無い全画面で遊べます。",
  "install.close": "OK",

  // ---- 試合中の表示 ----
  "hud.pause": "ポーズ",
  "hud.camera": "視点の切り替え",
  "hud.holdLeft": "残り {n}",
  "banner.approach": "敵部隊、接近",
  "banner.advance": "前進再開",
  "banner.bossEscape": "母艦撤退",
  "choice.toast": "{name}: {desc}",
  "choice.toastLv": "{name} Lv{level}: {desc}",

  // ---- 省電力 ----
  "sleep.title": "省電力モード",
  "sleep.resume": "画面をタップ(クリック)すると戻ります",
  "rotate.title": "スマホを縦にしてください",
  "rotate.sub": "このゲームは縦持ちで遊べます",

  // ---- ポーズ ----
  "pause.resume": "再開",
  "pause.rewind": "R.W.N.D.(残り {n})",
  "pause.quality": "描画",
  "pause.camera": "視点",
  "pause.lang": "言語",
  "pause.quit": "タイトルへ",
  "pause.howto": "遊び方(ミラの説明)",
  "sound.on": "音 ON",
  "sound.off": "音 OFF",

  // ---- 視点(config.graphics.cameras) ----
  "camera.chase": "背後",
  "camera.high": "斜め見下ろし",
  "camera.cockpit": "主観",

  // ---- 初めての出撃の前のミラの説明(index.html の #tutorial) ----
  "tutorial.say1": "まずはこれだけ覚えて！",
  "tutorial.say2": "ぶつからないように動いてね。",
  "tutorial.next": "次へ",
  "tutorial.launch": "出撃！",
  "tutorial.close": "閉じる",
  "tutorial.goodTitle": "取っていいもの",
  "tutorial.gem": "金のダイヤ",
  "tutorial.gemNote": "（経験値）",
  "tutorial.gemDesc": "集めるとレベルアップ。強化を選べる",
  "tutorial.repair": "緑の十字",
  "tutorial.repairNote": "（修理カプセル）",
  "tutorial.repairDesc": "SHIELD が回復する",
  "tutorial.badTitle": "避けるもの",
  "tutorial.pod": "ポッド",
  "tutorial.podNote": "（色つきの玉）",
  "tutorial.podDesc": "ぶつかると SHIELD が減る。攻撃は自動なので、近づきすぎないで",
  "tutorial.shot": "赤い弾・ビーム",
  "tutorial.shotDesc": "当たると SHIELD が減る。横へよけて",

  // ---- 撃墜・リプレイ・R.W.N.D. ----
  "dead.rewind": "R.W.N.D.(残り {n})",
  "dead.result": "結果へ",
  "replay.rewindHere": "ここから R.W.N.D.(残り {n})",
  "replay.close": "閉じる",
  "replay.photo": "写真を保存",
  "replay.photoSaved": "保存しました",
  "replay.photoShared": "共有しました",
  "replay.photoFailed": "保存できませんでした",
  "replay.photoText": "SENSEOFDOPA STAGE {n} の名場面。3分間、生き残れ。",
  "rescue.head": "再開のおまけ(DOPA {dopa})・戻った直後は少し無敵",
  "rescue.item": "{name}: {desc}({cost} DOPA)",
  "boost.heal.name": "修理",
  "boost.heal.desc": "SHIELD満タン",
  "boost.power.name": "出力ブースト",
  "boost.power.desc": "{seconds}秒 攻撃力×{damage}",

  // ---- 結果 ----
  "result.clearText": "おつかれさま！ カードの画面から、次の面も選べるよ。",
  "result.failText": "今回はここまで。格納庫で強くして、また挑戦しよう。",
  "result.bestNew": "(ベスト更新!)",
  "result.bestWas": "(ベスト {v})",
  "result.progress": "前進 {v} {best}",
  "result.kills": "撃墜 {v} {best}",
  "result.comboLevel": "最大コンボ {combo} / レベル {level}",
  "result.score": "SCORE {v} {best}",
  "result.retry": "もう一度",
  "result.replay": "リプレイを見る",
  "result.sister": "本当の戦場 SENSEOFVOID へ",
  "result.newRecord": "NEW RECORD: {list}",
  "result.achieved": "目標達成!",
  "result.nextGoals": "次の目標",
  "earned.score": "SCORE",
  "earned.clear": "クリア",
  "record.progress": "前進",
  "record.score": "SCORE",
  "record.kills": "撃墜",
  "record.combo": "最大コンボ",
  "record.level": "レベル",
  "shop.ready": "格納庫で「{name}」を強化できます!",
  "shop.short": "次の強化「{name}」まで あと {n} DOPA",

  // ---- 格納庫(src/meta/hangar.js の HANGAR) ----
  "hangar.back": "戻る",
  "hangar.upgrades": "強化",
  "hangar.max": "最大",
  "hangar.startWeapon": "最初から持って出る武器",
  "hangar.none": "なし",
  "hangar.records": "記録",
  "hangar.goals": "目標 {done}/{all}",
  "hangar.rewindEffect": "+{n}回",
  "hangar.shield.name": "装甲",
  "hangar.shield.desc": "SHIELDの最大値",
  "hangar.power.name": "出力",
  "hangar.power.desc": "すべての攻撃力",
  "hangar.xpGain.name": "学習",
  "hangar.xpGain.desc": "経験値の量",
  "hangar.magnet.name": "回収",
  "hangar.magnet.desc": "経験値を吸い寄せる範囲",
  "hangar.rewind.name": "R.W.N.D.",
  "hangar.rewind.desc": "R.W.N.D.の回数",
  "rec.bestProgress": "ベスト前進 {v}",
  "rec.bestScore": "ベストSCORE {v}",
  "rec.bestKills": "最多撃墜 {v}",
  "rec.bestCombo": "最大コンボ {v}",
  "rec.runs": "出撃 {runs} 回 / クリア {clears} 回",
  "rec.totalKills": "撃墜の合計 {v}",

  // ---- 目標(src/meta/goals.js の GOALS) ----
  "goal.reward": "{n} DOPA",
  "goal.rewardWeapon": "{n} DOPA + 武器",
  "goal.unlock": "解放: {weapon}を持って出撃",
  "goal.reach": "{place}に到達",
  "goal.kills": "1回で{n}機撃墜",
  "goal.combo": "{n}コンボ",
  "goal.level": "1回でレベル{n}",
  "goal.boss": "母艦を撃沈",
  "goal.clear": "3面をクリア",
  "goal.clear-norewind": "R.W.N.D.を使わずに3面をクリア",

  // ---- 武器・強化(src/sim/upgrades.js。文は src/ui/labels.js で組み立てる) ----
  "weapon.beam.name": "ビーム砲",
  "weapon.beam.desc": "近くの敵を自動で狙って撃つ",
  "weapon.spread.name": "拡散ビーム",
  "weapon.spread.desc": "輪になって広がるビームを前へ撃つ",
  "weapon.missile.name": "誘導ミサイル",
  "weapon.missile.desc": "敵を追いかけて爆発する",
  "weapon.saber.name": "ビームサーベル",
  "weapon.saber.desc": "機体のまわりを回って横の敵を斬る",
  "weapon.mainGun.name": "主砲",
  "weapon.mainGun.desc": "前方を貫く太いビームを時々撃つ",
  "weapon.beam.evo.name": "メガビーム砲",
  "weapon.spread.evo.name": "ストームリップル",
  "weapon.missile.evo.name": "クラスターミサイル",
  "weapon.saber.evo.name": "サーベルストーム",
  "weapon.mainGun.evo.name": "重力砲",
  "weapon.beam.evo.desc": "太いビームを嵐のように連射する",
  "weapon.spread.evo.desc": "大きなビームの輪を次々と広げる",
  "weapon.missile.evo.desc": "大量のミサイルで広く爆撃する",
  "weapon.saber.evo.desc": "たくさんの刃が広く回って切り刻む",
  "weapon.mainGun.evo.desc": "前方を飲み込む極太のビームを撃つ",
  "choice.evolve": "{from}が進化! {desc}",
  "choice.evoHint": "{passive}Lv{lv}で進化できる",
  "choice.evoTag": "進化",
  "hud.power": "攻撃力 +{p}%",
  "hud.chart": "強化の状態",
  "chart.title": "STATUS",
  "chart.pickHint": "オレンジの名前を押すと、その強化を選べる",
  "chart.close": "閉じる",
  "chart.evolved": "金色 = 進化",
  "passive.power.name": "出力強化",
  "passive.power.desc": "すべての攻撃力が上がる",
  "passive.haste.name": "冷却強化",
  "passive.haste.desc": "武器の撃つ間隔が短くなる",
  "passive.thruster.name": "推力強化",
  "passive.thruster.desc": "移動が速くなる",
  "passive.magnet.name": "回収範囲",
  "passive.magnet.desc": "経験値を遠くから吸い寄せる",
  "passive.shield.name": "SHIELD強化",
  "passive.shield.desc": "SHIELDの最大値が上がり、回復する",
  "heal.name": "SHIELD回復",
  "heal.desc": "SHIELDを{n}回復する",
  "choice.newWeapon": "新しい武器: {desc}",

  // ---- ステージ(config.stages。name は英語のまま両方で使う) ----
  "stage.orbit.place": "地球軌道",
  "stage.orbit.mila": "地球軌道、いくよ！",
  "stage.orbit.hint": "光る補給衛星を撃つと、経験値と修理カプセル",
  "stage.asteroid.place": "アステロイド帯",
  "stage.asteroid.mila": "アステロイド帯よ。",
  "stage.asteroid.hint": "赤く光る岩が流れてくる。撃って壊せる",
  "stage.colony.place": "廃コロニー",
  "stage.colony.mila": "廃コロニーに入るわ。",
  "stage.colony.hint": "赤いレーザーの柵から離れて",
  "stage.moon.place": "月面",
  "stage.moon.mila": "月面上空。母艦も来るよ！",
  "stage.moon.hint": "地上の対空砲と機雷に注意",
  "stage.atmosphere.place": "大気圏突入",
  "stage.atmosphere.mila": "大気圏突入！あと1分！",
  "stage.atmosphere.hint": "画面の端は熱い。真ん中へ",

  // ---- 敵が初めて出たとき(config.enemies.roster) ----
  "enemy.dasher.mila": "赤玉、来るよ！",
  "enemy.dasher.hint": "赤玉: 一直線に突っ込んでくる。横へ避けて",
  "enemy.gunner.mila": "青玉が撃ってくる！",
  "enemy.gunner.hint": "青玉: 止まって弾を撃つ。先に落とそう",
  "enemy.splitter.mila": "紫玉よ！",
  "enemy.splitter.hint": "紫玉: 倒すと2つに割れる",
  "enemy.mine.mila": "黄玉に気をつけて！",
  "enemy.mine.hint": "黄玉: 近づくと止まって爆発。撃ち落とせば周りを巻き込む",

  // ---- 停止戦(config.holds.list の id。hint は無くてもよい) ----
  "hold.miniboss.mila": "小母艦が来た！",
  "hold.miniboss.hint": "停止中: 小母艦も含めて全部倒すと前進再開",
  "hold.wave2.mila": "また囲まれた！",
  "hold.wave3.mila": "数が多い…動き回って！",
  "hold.bigpod.mila": "大玉…最後の敵よ！",
  "hold.bigpod.hint": "大玉: 上下の帯をねらうと大ダメージ",

  // ---- ミラの一言(mila.*)と遊び方の説明(hint.*) ----
  "mila.start": "出撃よ！",
  "hint.start": "移動するだけでOK。攻撃は全部自動",
  "mila.repaired": "回復したよ！",
  "mila.holdDefault": "囲まれた！",
  "mila.holdClear": "全滅確認！",
  "hint.holdClear": "ごほうびの修理カプセル(緑の十字)を拾おう",
  "mila.boss": "母艦が来る！",
  "hint.boss": "母艦の主砲(正面)の前から離れて",
  "mila.cannon": "主砲チャージ！ 動いて避けて！",
  "hint.cannon": "黄色い輪が狙い。撃つ前に横へ動けば当たらない",
  "mila.kill.boss": "母艦撃沈！ すごい！",
  "mila.kill.miniboss": "小母艦、撃破！",
  "mila.kill.bigpod": "大玉、撃破！ やったね！",
  "mila.kill.other": "撃破！",
  "mila.timeLeft": "残り{n}分！",
  "mila.bossEscape": "母艦が逃げた…！ 次で取り返そう",
  "mila.kills100": "100機撃墜！",
  "mila.levelUp": "強化を選んで！",
  "hint.levelUp": "迷ったら新しい武器がおすすめ",
  "mila.dead": "まだいける！",
  "mila.deadNoStock": "よく頑張ったね…",
  "hint.dead": "R.W.N.D.: 好きな時点まで戻ってやり直せる",
  "mila.rewindBoth": "やり直しよ！ 修理と出力ブーストつき！",
  "mila.rewindHeal": "やり直しよ！ SHIELDも直したわ。",
  "mila.rewindPower": "やり直しよ！ 出力ブーストで押し切って！",
  "mila.rewind": "やり直しよ！ 少しの間は無敵、さっきと違う動きで！",

  // ---- 面を選ぶカード・面のクリア(config.missions。src/meta/screens.js・src/main.js) ----
  "result.stages": "面を選ぶ",
  "result.retrySame": "同じ面をもう一度",
  "result.newStage": "STAGE {n} のカードが増えた!",
  "stages.locked": "STAGE {n} をクリアで解放",
  "stages.desc": "最後の敵: {finale} ・ 約{min}分",
  "stages.allClear": "全ての面をクリア！ 格納庫で強くして、さらに上を目指そう。",
  "finale.miniboss": "小母艦",
  "finale.boss": "母艦",
  "finale.bigpod": "大玉",
  "result.stageGoals": "STAGE {n} の目標",
  "stagegoal.clear": "この面をクリア",
  "stagegoal.norewind": "R.W.N.D.を使わずにクリア",
  "stagegoal.allholds": "停止戦を全て全滅させてクリア",
  "stagegoal.short.clear": "CLEAR",
  "stagegoal.short.norewind": "NO R.W.N.D.",
  "stagegoal.short.allholds": "全滅",
  "mc.link": "SENSEOFVOID をプレイする",
  "mc.next": "結果へ",
  "hold.finalMiniboss.mila": "小母艦！ これを落とせばクリアよ！",
  "hold.finalMiniboss.hint": "停止中: 小母艦を倒すとクリア",
  "mission.1.clear": "イメージがつかめたかな。次に進んでみる？",
  "mission.2.clear": "もっと行けるところまで行ってみよう",
  "mission.3.clear": "ここまで来てくれたキミにお願い。本当の戦場 SENSEOFVOID で、一緒に戦ってほしいの。",
  "mission.4.clear": "その腕、本物ね。SENSEOFVOID の戦場でも見せてくれる？",
  "mission.5.clear": "すごい…！ キミみたいなパイロットを、SENSEOFVOID で待ってる。",
  "mission.6.clear": "全部の面をクリア！ 本当にありがとう。続きは SENSEOFVOID で会いましょう。",
};
